export default "__VITE_ASSET__CFJ3$Rtk__"